import { render, staticRenderFns } from "./PermissionsCard.vue?vue&type=template&id=62a140ad&scoped=true"
import script from "./PermissionsCard.vue?vue&type=script&lang=js"
export * from "./PermissionsCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionsCard.vue?vue&type=style&index=0&id=62a140ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a140ad",
  null
  
)

export default component.exports